import * as React from 'react';
import ReactDOM from 'react-dom';
import 'Assets/Sass/style.scss';
import 'react-toastify/dist/ReactToastify.css';
import * as serviceWorker from './serviceWorker';
import App from './Components/App';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
